import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row-wr" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row-value" }
const _hoisted_5 = { class: "row secondary" }
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "row secondary" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = { class: "row secondary" }
const _hoisted_14 = { class: "row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Summmary", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-label" }, "Project", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.props.project), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "Lot Number", -1)),
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.lot), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Land Size", -1)),
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.formatPrice($setup.props.landSize, false)) + " sqm", 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-label" }, "Land Price", -1)),
        _createElementVNode("div", _hoisted_10, _toDisplayString($setup.formatPrice($setup.props.landPrice)), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-label" }, "Home Area", -1)),
        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatPrice($setup.props.homeArea, false)) + " sqm", 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-label" }, "Home Price", -1)),
        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.calculateBuildPriceOrPackagePriceTotal($setup.props.homePrice, $setup.props.facadePrice, $setup.props.siteCosts)), 1)
      ])
    ])
  ]))
}